
import styles from '../style.module.css';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function NewsItem({ news }) {

    const { currentLanguage } = useSelector(({ main }) => main);
    const navigate = useNavigate();

    const prefix = currentLanguage !== "hy" ? `/${currentLanguage}` : "";

    return (
        <div
            className={styles.news_item}
            onClick={() => navigate(`${prefix}/blog/${news.slug}`)}
        >
            <div className={styles.news_item_image_box}>
                <img
                    src = {process.env.REACT_APP_STORAGE_URL + news["image_url_" + currentLanguage]}
                    alt = {news["title_" + currentLanguage] || "news"}
                />
            </div>
            <p className={styles.news_item_title}>
                { news['title_' + currentLanguage] }
            </p>
        </div>
    )
}
